import { computed, ref } from 'vue'

import { useRenameFolderMutation } from '@/shared/graphql/legacy/generated'
import type { Folder } from '@/shared/graphql/router/graphql'
import { useExplorerStore } from '@/features/explorer/store'
import { renameFolderInExplorerCache } from '@/features/explorer/utils/explorerCache'

export function useRenameFolder(item: Folder) {
  const { mutate: renameFolder, loading } = useRenameFolderMutation()
  const explorerStore = useExplorerStore()

  const name = ref(item.name)
  const error = ref('')

  const isSameName = computed(() => name.value.trim() === item.name.trim())

  const save = async () => {
    try {
      await renameFolder(
        {
          id: item.id,
          newFolderName: name.value,
        },
        {
          update() {
            renameFolderInExplorerCache(item.id, name.value)

            const newUrl = new URL(window.location.href)

            if (newUrl.pathname.includes(encodeURIComponent(item.name))) {
              const folderPath = explorerStore.currentFolder?.path || '/'
              const parentPath =
                folderPath === '/'
                  ? '/'
                  : folderPath.substring(0, folderPath.lastIndexOf('/') + 1) ||
                    '/'
              newUrl.pathname = `/home${parentPath}${name.value}`
              window.history.pushState({}, '', newUrl.toString())
            }
          },
        }
      )

      return true
    } catch (err) {
      console.error(err)

      if (err instanceof Error && err.message.includes('already')) {
        error.value = 'A folder with this name is already taken'
      }

      return false
    }
  }

  return { name, error, loading, isSameName, save }
}
